import { useState } from "react";

export default  function FormBox({className="", label, placeholder, inputClass="",onChange, type="text",value,name,error,disabled,min,max }) {
    // const [inputValue, setInputValue] = useState("");
    // const handleChangeValue = (event) => {
    //     setInputValue(event.target.value);
    //     onChange(event.target.value);
    // };

    return (
        <div className={`form-box ${className}`}>
            {label && <label htmlFor="#" className="form-label mb-2 fs-14 fw-medium text-heading">{label}</label>}
            <input
            disabled={disabled}
            name={name}
                className={`form-control ${inputClass}`}
                type={type}
                min={min}
                max={max}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
            />

             <div className="text-danger fs-12">{error}</div>

        </div>
    );
}
